import browserType from "./browserType";
// 使用时请尽量在nickTick中调用此方法
// https://cn.vuejs.org/v2/guide/reactivity.html
//打印
export default (refs,fn) => {
  let cloneN;
  if(Array.isArray(refs)){
    cloneN = refs[0].cloneNode(true);
  }else{
    cloneN = refs.cloneNode(true);
  }

  const body = document.getElementsByTagName('body')[0];
  cloneN.style.position = 'absolute';
  cloneN.style.zIndex = '99999999999999999999';
  cloneN.style.top = 0;
  cloneN.style.left = 0;
  cloneN.style.width = '100%';
  cloneN.style.minHeight = '100%';
  cloneN.style.background = '#fff';
  body.appendChild(cloneN);
  // 开始打印
  window.print();
  // 移出节点
  body.removeChild(cloneN);
  // 回调
  if(fn){
    fn();
  }
};



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/printHTML.js